export const resultContent = [
  {
    heading_discription:
      "The results from our calculator provide an estimate of how much you could save by moving your debt to a low-interest loan or credit card. This is based on two scenarios:",
    subheadingOne: " Pay off the debt with your current lender: ",
    subheadingOne_discription:
      "Calculate the interest and total amount payable if you continue repaying your debt at the current high-interest rate.",

    // tip one

    tipOne:
      " Adjust the repayment period in the calculator to explore how different terms impact your total interest cost. Additionally, consider converting your credit card debt into fixed EMIs or opting for a Personal Loan on Credit Card (PLCC) offered by many banks to save on interest.",
    subheadTwo:
      "Move to a Balance Transfer Option With a Lower Interest Rate: ",
    subheadTwo_description:
      "Compare the potential savings by transferring to a lower-interest loan or card and paying it off within a specified period.",
  },
];

export const choosingBTdata = [
  {
    heading: "Choosing the Right Balance Transfer Option",
    headDescription:
      "Selecting an appropriate balance transfer option is crucial for effective debt management. Consider the following factors to make an informed decision:",

    subheadOne: "Balance Transfer Fees:",
    subheadOneList: [
      {
        heading: "Overview:",
        description:
          "Banks typically charge a fee for processing balance transfers, usually ranging between 1% to 3% of the transferred amount.",
      },
      {
        heading: "Consideration: ",
        description:
          "  Ensure that the interest savings from the lower rate outweigh the transfer fee. For instance, if you’re transferring ₹1,00,000 and the fee is 2%, you’ll incur a ₹2,000 charge.",
      },
    ],
    subheadTwo: "Interest Rate Differential:",
    subheadTwoList: [
      {
        heading: "Overview:",
        description:
          "The difference between your current interest rate and the new rate offered by the balance transfer option.",
      },
      {
        heading: "Consideration: ",
        description:
          " A significant reduction in the interest rate can lead to substantial savings. For example, moving from a 24% APR to a 12% APR can halve your interest expenses.",
      },
    ],
    subheadThree: "Lender’s Reputation and Practices:",
    subheadThreeList: [
      {
        heading: "Overview:",
        description:
          "The credibility and customer service quality of the new bank or financial institution.",
      },
      {
        heading: "Consideration: ",
        description:
          "  Opt for lenders known for transparent practices and efficient customer support. Research their debt collection methods to avoid potential issues.",
      },
    ],
    subheadFour: "Rewards and Benefits:",
    subheadFourList: [
      {
        heading: "Overview:",
        description:
          " Some credit cards offer rewards like cashback, travel points, or discounts.",
      },
      {
        heading: "Consideration: ",
        description:
          " While rewards are beneficial, prioritize lower interest rates and favorable terms over perks. However, if two options are similar in rates and fees, choose the one with better rewards.",
      },
    ],
    subheadFive: "Repayment Terms and Conditions:",
    subheadFiveList: [
      {
        heading: "Overview:",
        description: "The duration and flexibility of the repayment period.",
      },
      {
        heading: "Consideration: ",
        description:
          "  Ensure the repayment tenure aligns with your financial capacity. Longer tenures may reduce monthly payments but could increase total interest paid.",
      },
    ],
    tipTwo:
      "Before finalizing a balance transfer, calculate the total cost, including transfer fees and interest over the repayment period, to ensure genuine savings.",

    // text after second tip
  },
];
